module.exports = __webpack_public_path__ + "static/media/videogame.948686eb.png";